import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateEmailQuery } from './useEmailQuery';

interface IVariables {
	campaignId: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useEnableCampaignPublicShareMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (publicShareCode: string, variables: IVariables) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ campaignId, impersonationContext }: IVariables) =>
			userSession.webServiceHelper.callAsync<string>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `email/${encodeURIComponent(campaignId)}/publicShare`,
					impersonationContext,
				}),
				'POST'
			),
		onError,
		onSuccess: (publicShareCode, variables) => {
			invalidateEmailQuery(queryClient, variables.campaignId);
			onSuccess?.(publicShareCode, variables);
		},
	});
}
